"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GeminiHandwritingEngine = void 0;
class GeminiHandwritingEngine {
    /**
     * Mock implementation of handwriting recognition.
     */
    async recognizeHandwriting(strokes) {
        console.log('[Gemini] Recognizing handwriting...');
        return {
            text: "Alpha",
            confidence: 0.98
        };
    }
    async analyzeCraftsmanship(strokes, targetText) {
        console.log('[Gemini] Analyzing craftsmanship...', strokes.length, 'strokes');
        // Calculate a dynamic score based on stroke properties
        let score = 70; // Base score
        let feedback = "Keep practicing!";
        const suggestions = [];
        if (strokes.length === 0) {
            return {
                score: 0,
                feedback: "No strokes detected. Try drawing the letter!",
                suggestions: ["Draw on the canvas to practice"],
                details: { strokeCount: 0 }
            };
        }
        // Analyze stroke properties
        const totalPoints = strokes.reduce((acc, s) => acc + (s.points?.length || 0), 0);
        const avgPointsPerStroke = totalPoints / strokes.length;
        // More points = smoother strokes = better
        if (avgPointsPerStroke > 20) {
            score += 10;
        }
        else if (avgPointsPerStroke < 5) {
            score -= 10;
            suggestions.push("Try drawing more smoothly without lifting");
        }
        // Calculate stroke length consistency
        const strokeLengths = strokes.map(s => {
            if (!s.points || s.points.length < 2)
                return 0;
            let length = 0;
            for (let i = 1; i < s.points.length; i++) {
                const dx = s.points[i].x - s.points[i - 1].x;
                const dy = s.points[i].y - s.points[i - 1].y;
                length += Math.sqrt(dx * dx + dy * dy);
            }
            return length;
        });
        const avgLength = strokeLengths.reduce((a, b) => a + b, 0) / strokeLengths.length;
        // Good stroke length indicates intentional, controlled writing
        if (avgLength > 50 && avgLength < 500) {
            score += 10;
        }
        // Number of strokes (letters typically need 1-4 strokes)
        if (strokes.length >= 1 && strokes.length <= 4) {
            score += 5;
        }
        else if (strokes.length > 6) {
            suggestions.push("Try using fewer, more confident strokes");
        }
        // Clamp score to 0-100
        score = Math.max(0, Math.min(100, score));
        // Generate feedback based on score
        if (score >= 90) {
            feedback = "Excellent work! Your letter formation is nearly perfect!";
        }
        else if (score >= 80) {
            feedback = "Great job! Your handwriting is clear and well-formed.";
        }
        else if (score >= 70) {
            feedback = "Good effort! Keep practicing to improve consistency.";
        }
        else if (score >= 50) {
            feedback = "Nice try! Focus on following the letter shape more closely.";
        }
        else {
            feedback = "Keep practicing! Try to trace the guide letter more carefully.";
        }
        // Add default suggestions if none
        if (suggestions.length === 0) {
            if (score < 90) {
                suggestions.push("Keep the pen on the paper for smoother lines");
                suggestions.push("Follow the guide letter shape closely");
            }
            else {
                suggestions.push("Great work! Try the next letter");
            }
        }
        return {
            score,
            feedback,
            suggestions,
            details: {
                strokeCount: strokes.length,
                totalPoints,
                avgPointsPerStroke: Math.round(avgPointsPerStroke),
                avgStrokeLength: Math.round(avgLength)
            }
        };
    }
}
exports.GeminiHandwritingEngine = GeminiHandwritingEngine;
